__turbopack_context__.v({
  "base": "PromoBadge-module-scss-module__mba23q__base",
  "clearance": "PromoBadge-module-scss-module__mba23q__clearance",
  "hit": "PromoBadge-module-scss-module__mba23q__hit",
  "new": "PromoBadge-module-scss-module__mba23q__new",
  "pdp": "PromoBadge-module-scss-module__mba23q__pdp",
  "sale": "PromoBadge-module-scss-module__mba23q__sale",
});
